<app-student-nav></app-student-nav>

<div class="settings-page">
  <div class="settings-container">
    <h1 class="settings-title">Settings</h1>

    <!-- Account -->
    <mat-card class="settings-card">
      <mat-card-header class="settings-card-header">
        <mat-card-title class="settings-card-title">Account</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="settings-card-body">
        <div class="settings-row" aria-label="Email: {{ currentUser?.email }}">
          <div class="settings-row-info">
            <div class="settings-row-label" aria-hidden="true">Email</div>
            <div class="settings-row-value" aria-hidden="true">{{ currentUser?.email }}</div>
          </div>
        </div>

        <mat-divider aria-hidden="true"></mat-divider>

        <div class="settings-row" aria-label="Type: {{ currentUser?.userType }}">
          <div class="settings-row-info">
            <div class="settings-row-label" aria-hidden="true">Type</div>
            <div class="settings-row-value" aria-hidden="true">{{ currentUser?.userType }}</div>
          </div>
        </div>

        <mat-divider aria-hidden="true"></mat-divider>

        <div class="settings-row" aria-label="Signed in with Google">
          <div class="settings-row-info">
            <div class="settings-row-label" aria-hidden="true">Signed in with</div>
            <div class="settings-row-value" aria-hidden="true">Google</div>
          </div>
        </div>

        <mat-divider aria-hidden="true"></mat-divider>

        <div class="settings-row">
          <div class="settings-row-info">
            <div class="settings-row-label">Log out</div>
            <div class="settings-row-desc">Sign out of your Handle account.</div>
          </div>
          <a
            mat-stroked-button
            href="/logout"
            class="btn-logout"
            aria-label="Log out of your Handle account"
          >
            Log out
          </a>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Notifications -->
    <mat-card class="settings-card">
      <mat-card-header class="settings-card-header">
        <mat-card-title class="settings-card-title">Notifications</mat-card-title>
      </mat-card-header>
      <mat-divider aria-hidden="true"></mat-divider>
      <mat-card-content class="settings-card-body">
        <div class="settings-row">
          <div class="settings-row-info">
            <div class="settings-row-label">Email notifications</div>
            <div class="settings-row-desc">
              Get an email about things you haven't seen in the app. Group chats are never emailed.
            </div>
          </div>
          <mat-slide-toggle
            class="email-notifications-toggle"
            color="primary"
            [checked]="emailSettings.enabled"
            [disabled]="!emailSettingsLoaded || emailSettingsSaving"
            (change)="toggleEmailNotifications($event)"
            aria-label="Toggle email notifications"
          >
          </mat-slide-toggle>
        </div>

        @if (emailSettings.enabled) {
          @for (category of emailCategories; track category.key) {
            <mat-divider aria-hidden="true"></mat-divider>
            <div class="settings-row">
              <div class="settings-row-info">
                <div class="settings-row-label">{{ category.label }}</div>
                <div class="settings-row-desc">{{ category.description }}</div>
              </div>
              <mat-slide-toggle
                class="email-category-toggle"
                color="primary"
                [checked]="emailSettings.types[category.key]"
                [disabled]="!emailSettingsLoaded || emailSettingsSaving"
                (change)="toggleEmailCategory(category.key, $event)"
                [attr.aria-label]="'Toggle emails for ' + category.label"
              >
              </mat-slide-toggle>
            </div>
          }

          <mat-divider aria-hidden="true"></mat-divider>
          <div class="settings-row">
            <div class="settings-row-info">
              <div class="settings-row-label">Daily digest</div>
              <div class="settings-row-desc">
                Get one summary email each morning instead of emails as things happen.
              </div>
            </div>
            <mat-slide-toggle
              class="email-digest-toggle"
              color="primary"
              [checked]="emailSettings.digest"
              [disabled]="!emailSettingsLoaded || emailSettingsSaving"
              (change)="toggleEmailDigest($event)"
              aria-label="Toggle daily digest"
            >
            </mat-slide-toggle>
          </div>
        }
      </mat-card-content>
    </mat-card>

    <!-- Hidden Posts -->
    <mat-card class="settings-card">
      <mat-card-header class="settings-card-header">
        <mat-card-title class="settings-card-title">Hidden Posts</mat-card-title>
      </mat-card-header>
      <mat-divider aria-hidden="true"></mat-divider>
      <mat-card-content class="settings-card-body">
        @if (hiddenLoading) {
          <div class="hidden-loading" aria-label="Loading hidden posts">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        } @else if (hiddenPosts.length === 0) {
          <div class="hidden-empty" aria-label="No hidden posts">
            <p class="hidden-empty-text">You haven't hidden any posts.</p>
          </div>
        } @else {
          @for (post of hiddenPosts; track post.id) {
            <div
              class="settings-row"
              [attr.aria-label]="'Hidden post by ' + (post.user?.firstName || 'Unknown')"
            >
              <div class="settings-row-info">
                <div class="settings-row-label">
                  {{ post.user?.firstName }} {{ post.user?.lastName }}
                </div>
                <div class="settings-row-desc">{{ truncateContent(post.content) }}</div>
              </div>
              <button
                mat-stroked-button
                class="btn-logout"
                (click)="unhidePost(post.id)"
                [disabled]="unhidingIds.has(post.id)"
                [attr.aria-label]="'Unhide post by ' + (post.user?.firstName || 'Unknown')"
              >
                {{ unhidingIds.has(post.id) ? 'Unhiding...' : 'Unhide' }}
              </button>
            </div>
            <mat-divider aria-hidden="true"></mat-divider>
          }
        }
      </mat-card-content>
    </mat-card>

    <!-- Danger zone -->
    <app-deletion></app-deletion>
  </div>
</div>
